import { Link, useNavigate } from "react-router-dom"
import { adminLogout } from "@/api/adminAuthApi"
import { useAdminAuth } from "@/contexts/AdminAuthContext"
import { Button } from "@/components/ui/button"

export default function AdminHeader() {
    const navigate = useNavigate()
    const { clearAdminAuth } = useAdminAuth()

    const handleLogout = async () => {
        try {
            await adminLogout()
            clearAdminAuth()
            navigate("/admin/login", { replace: true })
        } catch (error) {
            console.error(error)
            alert("로그아웃 중 오류가 발생했습니다.")
        }
    }

    return (
        <header className="sticky top-0 z-30 border-b border-slate-200 bg-white/90 backdrop-blur">
            <div className="mx-auto flex max-w-[1600px] items-center justify-between px-4 py-4 lg:px-6">
                <div>
                    <h1 className="text-xl font-bold text-slate-900">관리자 콘솔</h1>
                    <p className="text-sm text-slate-500">
                        상품, 주문, 회원, 배너를 관리하세요.
                    </p>
                </div>

                <div className="flex items-center gap-2">
                    <Button asChild variant="outline" className="rounded-xl">
                        <Link to="/">사용자몰 보기</Link>
                    </Button>
                    <Button className="rounded-xl" onClick={handleLogout}>
                        로그아웃
                    </Button>
                </div>
            </div>
        </header>
    )
}